import { render, staticRenderFns } from "./PrimaryNavChinese.vue?vue&type=template&id=10132ed2&scoped=true"
import script from "./PrimaryNavChinese.vue?vue&type=script&lang=js"
export * from "./PrimaryNavChinese.vue?vue&type=script&lang=js"
import style0 from "./PrimaryNavChinese.vue?vue&type=style&index=0&id=10132ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10132ed2",
  null
  
)

export default component.exports